export const sessionAttendance = {
    state: {
        sessionAttendanceParticipants: [],

        selectedParticipants: [],
        selectedCrews: [],
        selectedSquads: []
    },

    getters: {
        sessionAttendanceParticipants(state) {
            return _.sortBy(state.sessionAttendanceParticipants, 'user.data.last_name');
        },

        sessionAttendanceSelectedParticipants(state) {
            return _.sortBy(state.selectedParticipants, 'user.data.last_name');
        },

        sessionAttendanceSelectedCrews(state) {
            return _.sortBy(state.selectedCrews, 'name');
        },

        sessionAttendanceSelectedSquads(state) {
            return _.sortBy(state.selectedSquads, 'name');
        }
    },

    mutations: {
        setSessionAttendanceParticipants(state, data) {
            state.sessionAttendanceParticipants = data;
        },

        setSessionAttendanceSelectedParticipants(state, data) {
            state.selectedParticipants = data;
        },

        setSessionAttendanceSelectedCrews(state, data) {
            state.selectedCrews = data;
        },

        setSessionAttendanceSelectedSquads(state, data) {
            state.selectedSquads = data;
        }
    }
};
